import useTranslation from 'next-translate/useTranslation'
import { roles } from '@/data/jobData'
import { nonEmptyPropertiesCount } from '@/helpers/utils'

interface iProps {
  locations: string[]
  filters: any
}
const JobLinks = ({ locations, filters }: iProps) => {
  const { t } = useTranslation()

  const technologies = [
    'Java',
    'JavaScript',
    'Python',
    'C#',
    'C++',
    'PHP',
    'Go',
    'Kotlin',
    'React',
    'Angular',
  ]

  if (nonEmptyPropertiesCount(filters) > 0) {
    return null
  }

  return (
    <section className='bg-action py-4'>
      <div className='container h-full my-10'>
        <h3 className='mt-10 text-3xl text-white'>
          {t('search:popular_roles')}
        </h3>
        <div className='flex flex-wrap gap-6 text-white my-12'>
          {roles.map((role) => (
            <a href={`/companies/jobs/s/role,${role.value}`}>
              {t(`common:role_${role.value}`)}
            </a>
          ))}
        </div>
        <h3 className='mt-10 text-3xl text-white'>
          {t('search:popular_locations')}
        </h3>
        <div className='flex flex-wrap gap-6 text-white my-12'>
          {locations.map((location) => (
            <a href={`/companies/jobs/s/city,${location}`}>{location}</a>
          ))}
        </div>
        <h3 className='mt-10 text-3xl text-white'>
          {t('search:popular_tech')}
        </h3>
        <div className='flex flex-wrap gap-6 text-white my-12'>
          {technologies.map((tech) => (
            <a href={`/companies/jobs/s/skills,${tech}`}>{tech}</a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default JobLinks
